export const defaultMessage = "Price range reflects card value.";
export const minMaxRangeError =
  "Minimum amount must be lower or equal to the maximum amount.";
export const outOfRangeError = "Enter an amount between $5 - $2000.";
